import { addDaysToDateOnly, currentBusinessDate, dateOnlyFromValue } from "./timezone";

export default function getLastDateOfPreviousMonth(date) {
  const dateOnly = dateOnlyFromValue(date || currentBusinessDate());
  const [year, month] = dateOnly.split("-").map(Number);
  const firstDay =
    String(year).padStart(4, "0") +
    "-" +
    String(month).padStart(2, "0") +
    "-01";
  return addDaysToDateOnly(firstDay, -1);
}
